module.exports = __webpack_public_path__ + "img/ic-selec-arrow.42f5a8bd.svg";